import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/styles";
import findByString from "../../Utils/getValueByString";
import FieldWrapper from "../../FieldWrapper";
import {FormControl} from "@material-ui/core";
import request from "../../../../../Services/API/Requests";
import update from "immutability-helper";
import asyncForEach from "../../Utils/asyncForEach";
import {errorHandler} from "../../Utils/errorHandler";
import FieldErrorMessage from "../../Utils/errorMessage";
import {setArrayPath} from "../../Utils/setArrayPath";
import {checkHidden} from "../../Utils/checkHidden";
import {checkEvents} from "../../Utils/checkEvents";
import SimpleField from "./SimpleField";
import ArrayField from "./ArrayField";
import {getNextScreenId} from "../../../../../Components/JsonScreen/Utils/getNextScreenDest";
import {getParamsFromString} from "../../../../../Components/JsonScreen/Utils";

const styles = () => ({
    fieldWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative'
    },
    formControl: {
        minWidth: 'auto'
    }
});

class TypeEntity extends Component {
    constructor(props) {
        super(props);
        this.fieldRef = React.createRef();
        this.state = {
            initialValue: {},
            createScreen: null,
            isOpenCreate: false,
            fieldValue: {},
            filterValue: "",
            errorComponent: false,
            changed: false,
            isOpen: false,
            loading: false,
            events: {},
            error: '',
            path: '',
            fieldSchema: null,
            usedLabel: false,
            enrichmentCache: [],
            formLabelUsed: false,
        }
    }

    componentDidMount = async () => {
        const {onBlurFromCell, field, focusNow, events, errors, containerArrayPath} = this.props;
        if (focusNow && field.disabled) {
            onBlurFromCell();
        }
        if (focusNow) {
            this.fieldRef.current.focus()
        }
        if (events.length) {
            this.setEvents();
        }
        if (errors) {
            let errorField = errorHandler(errors, field.path, containerArrayPath);
            if (errorField) {
                this.setState({error: errorField})
            }
            if (!errorField && this.state.error) {
                this.setState({error: false})
            }
        }
        await this.setValues();
    };

    componentDidUpdate = async (prevProps) => {
        const {values, errors, field: {path}, containerArrayPath} = this.props;
        const {values: prevValues, errors: prevErrors, field: {path: prevPath}} = prevProps;
        const arrayPath = setArrayPath(path, containerArrayPath);
        const prevValue = findByString(prevValues, arrayPath ? arrayPath : path);
        const value = findByString(values, arrayPath ? arrayPath : path);
        if (value !== prevValue) {
            await this.setValues();
        }
        if (JSON.stringify(errors) !== JSON.stringify(prevErrors)) {
            this.setErrors();
        }
        if (path !== prevPath) {
            await this.setValues();
        }
    };

    componentDidCatch(error, errorInfo) {
        this.setState({errorComponent: true});
        console.log(error, errorInfo)
    }

    setValues = async () => {
        const {
            values,
            field: {path, entity, isArray, returnType, optLabel, formInfo: {label: enrichmentLabel} = {}} = {},
            containerArrayPath
        } = this.props;
        const {usedLabel} = this.state;
        let arrayPath = setArrayPath(path, containerArrayPath);
        let value = findByString(values, arrayPath ? arrayPath : path);
        let preparedValue;

        if (!isArray) {
            let label = '';
            if (returnType === 'object') {
                label = value ? value[optLabel] : ""
            } else {
                //set values for entity
                label = value ? usedLabel ? await this.getLabel(entity, value) : enrichmentLabel ? enrichmentLabel :
                    value ? await this.getLabel(entity, value) : '' : '';
            }

            preparedValue = {label: `${label}`, value: value};
        } else {
            let checkForArrayValue = value ? Array.isArray(value) ? value : [value] : [];
            //set values for entityArray
            preparedValue = checkForArrayValue ?
                await this.getLabel(entity, checkForArrayValue, isArray) : []
        }
        this.setState({
            values,
            initialValue: preparedValue,
            fieldValue: preparedValue,
            loading: false,
            usedLabel: true,
            path: arrayPath ? arrayPath : path,
        });
    };
    setFieldSchema = async (resolve) => {
        const {field: {schema, entity}} = this.props;
        const fieldSchema = schema ? schema : await request({
            url: 'schema/read',
            data: {
                id: entity
            }
        });
        const createScreen = fieldSchema.editScreen ? getNextScreenId(fieldSchema.editScreen) : entity;
        this.setState({
            fieldSchema,
            createScreen
        }, async () => {
            resolve();
            await this.setValues();
        })

    }
    setErrors = () => {
        const {errors} = this.props;
        const {path} = this.state;
        let errorField = errorHandler(errors, path);
        this.setState({error: errorField})

        if (errorField) {
            this.setState({error: errorField})
        }

        if (!errorField && this.state.error) {
            this.setState({error: false})
        }

    };
    setEvents = () => {
        const {events} = this.props;
        const currentEvents = checkEvents(events);
        this.setState({events: currentEvents})
    };
    getLabel = async (entity, value, isArray) => {
        const {enrichmentCache} = this.state;
        const {field, containerArrayPath} = this.props;
        const apiLabel = field?.formInfo?.label
        const arrayPath = setArrayPath(field.path, containerArrayPath);
        let fieldPath =  arrayPath ? arrayPath : field.path;
        const parentEntity = fieldPath.split('.')[0];
        this.setState({loading: true});
        if (!isArray) {
            try {
                const findInCache = enrichmentCache.findIndex(f => f.value === value);

                //return label from api2 response
                if (apiLabel && !this.state.formLabelUsed) {
                    this.setState({formLabelUsed: true})
                    return apiLabel
                }

                if (findInCache === -1) {
                    let getLabel = await request({
                        url: `system/getLabel`,
                        method: 'POST',
                        data: {
                            entity,
                            id: value,
                            parent: parentEntity,
                            field: fieldPath?.split('.').slice(1).join('.')
                        }
                    });
                    this.setState((prevState) => ({
                        loading: false,
                        enrichmentCache: [...prevState.enrichmentCache, {value, label: getLabel.label}]
                    }));
                    return getLabel.label;
                }
                this.setState({loading: false})
                return enrichmentCache[findInCache].label
            } catch (e) {
                console.log(e);
                this.setState({loading: false});
                return value || ""
            }
        } else {
            let currentValue = [];
            await asyncForEach(value, async (id) => {
                try {
                    const findInCache = enrichmentCache.findIndex(f => f.value === id);
                    if (findInCache === -1) {
                        let getLabel = await request({
                            url: `system/getLabel`,
                            method: 'POST',
                            data: {
                                id,
                                entity,
                                parent: parentEntity,
                                field: arrayPath
                            }
                        });
                        this.setState(prevState => ({
                            enrichmentCache: [...prevState.enrichmentCache, {value: id, label: getLabel.label}]
                        }))
                        currentValue.push({label: getLabel.label, value: id});
                        return
                    }
                    currentValue.push(enrichmentCache[findInCache])
                } catch (e) {
                    console.log(e);
                    currentValue.push({label: id, value: id});
                    this.setState({loading: false})
                }
            });
            this.setState({loading: false});
            return currentValue;
        }

    };

    swapItems = (dragIndex, hoverIndex) => {
        const {fieldValue} = this.state;
        let newArr = update(fieldValue, {
            $splice: [[dragIndex, 1], [hoverIndex, 0, fieldValue[dragIndex]]],
        });
        this.setState({fieldValue: newArr})
    };
    endDrag = () => {
        const {fieldValue, path} = this.state;
        const {field: {trackChange}, setValue} = this.props;
        setValue(fieldValue.map(i => {
            return i.value
        }), path, trackChange);
        this.setState({changed: false})
    };

    onChangeField = (event) => {
        const {target: {value}} = event;
        this.setState({filterValue: value})
    };

    onChange = async (values) => {
        const {field: {isArray, entity, trackChange}, setValue, doActions, actionsContext} = this.props;
        const {path, events} = this.state;
        let newValue;
        if (isArray) {
            newValue = await this.getLabel(entity, values.map(i => {
                return i.value
            }), isArray)

            setValue(newValue.map(i => {
                return i.value
            }), path, trackChange)
            if (events.onChange) {
                doActions(events.onChange, {
                    currentField: {
                        value: newValue.map(i => {
                            return i.value
                        })
                    },
                    doc: actionsContext.doc
                })
            }
            return
        } else {
            newValue = {};
        }
        if (events.onChange) {
            doActions(events.onChange, {currentField: {value: newValue}, doc: actionsContext.doc})
        }
        this.setState({filterValue: '', fieldValue: newValue, changed: true})
    };

    onChangeFromDropDown = async (value) => {
        const {path, events, fieldValue} = this.state;
        const {actionsContext} = this.props;
        let context = typeof value === 'object' ? Object.assign({}, value) : value;
        const {
            field: {isArray, entity, trackChange, returnType, optLabel = "label"},
            setValue, onSelect, doActions
        } = this.props;

        if (isArray) {

            const isExists = fieldValue.find(v => v.value === value);
            const newValue = await this.getLabel(entity, [value], isArray)

            let newV =
                //if value is array, use value as final value
                Array.isArray(value) ? value.map(v => {
                        return {
                            value: v, label: v
                        }
                    }) :
                    //if exists value , remove the value from array
                    isExists ? fieldValue.filter(v => v.value !== value) :
                        Array.isArray(fieldValue) ?
                            [...fieldValue, ...newValue] : newValue

            this.setState({
                fieldValue: newV,
                filterValue: '',
                changed: true
            }, () => {

                setValue(newV.map(i => {
                    return i.value
                }), path, trackChange);
                if (events.onChange) {
                    doActions(events.onChange, {
                        currentField: {
                            value: newV.map(i => {
                                return i.value
                            })
                        }
                    })
                }
                if (onSelect) {
                    //do on select callback
                    onSelect(this.state.fieldValue)
                }
            })
            return
        } else {

            let newValue = {value: "", label: ""};

            if (returnType === 'object') {
                newValue = {value: value, label: value[optLabel]}
            } else {
                let tmpValue = value;

                //if dropdown returns whole object, find id for value, and pass for event-onChange object
                if (typeof tmpValue === 'object') {
                    tmpValue = value.id
                }
                newValue = {value: tmpValue, label: await this.getLabel(entity, tmpValue)}
            }


            this.setState({
                fieldValue: newValue,
                filterValue: '',
                changed: true
            }, () => {
                setValue(this.state.fieldValue.value, path, trackChange);
                if (onSelect) {
                    //do on select callback
                    onSelect(this.state.fieldValue)
                }
            })
        }
        if (events.onChange) {
            doActions(events.onChange, {currentField: {value: context}, doc: actionsContext.doc})
        }
    };

    onBlur = () => {
        const {fieldValue, changed, path} = this.state;
        const {field: {trackChange, isArray}, setValue, focusNow, onBlurFromCell} = this.props;
        if (changed) {
            if (isArray) {
                setValue(fieldValue.map(i => {
                    return i.value
                }), path, trackChange);
                this.setState({changed: false})
            } else {
                setValue(fieldValue.value, path, trackChange);
                this.setState({changed: false})
            }

        }
        if (focusNow) {
            onBlurFromCell();
        }
        this.setState({filterValue: ""})
    };
    setInitialValue = () => {
        this.setState(state => ({changed: false, fieldValue: state.initialValue}))
    };
    setDropdownState = (state) => {
        const {setDropdownState, field: {disabled}} = this.props;
        if (disabled) return;
        this.setState({isOpen: state});
        setDropdownState(state)
    };
    closeCreatePopup = () => {
        this.setState({isOpenCreate: false});
        this.setDropdownState(true)
    };
    openCreatePopup = async (entity) => {
        const schema = await request({
            url: 'schema/read',
            data: {
                id: entity
            }
        });
        const createScreen = schema.editScreen ? getNextScreenId(schema.editScreen) : entity;

        this.setState({isOpenCreate: true, createScreen});
        this.setDropdownState(false)
    };
    setCreatedRecord = async (record) => {
        await this.onChangeFromDropDown(record);
    };

    render() {
        const {
            errorComponent,
            filterValue,
            fieldValue,
            loading,
            error,
            isOpen,
            path,
            isOpenCreate,
            createScreen
        } = this.state;
        const {
            classes,
            field: {
                isArray,
                disabled,
                type,
                label,
                required,
                dropdown,
                entity,
                autofocus,
                hideCondition,
                restrictCreate = true,
                placeholder,
                dropdownContext,
            },
            field,
            fieldStyles,
            labelStyles,
            dropdownStyles,
            showLabel,
            goBack,
            errors = [],
            focusNow,
            history,
            onFocus,
            onKeyDown,
            onBlur,
            id,
            isMobile,
            globalValues,
            actionsContext,
            doActions,
            screenName,
            events
        } = this.props;
        const conditionalStyles = getParamsFromString(fieldStyles.conditionalStyles, {
                ...globalValues,
                doc: {
                    currentField: {value: fieldValue?.value}
                }
            },
            screenName)
        const isHidden = checkHidden({...globalValues, ...actionsContext}, hideCondition, screenName);
        const isDisabled = checkHidden({...globalValues, ...actionsContext}, disabled, screenName);
        const dropdownContextValue = getParamsFromString(dropdownContext, globalValues, screenName)
        const fieldPresentation = fieldStyles.presentation ?
            fieldStyles.presentation === 'inlineWithLabel' ? 'standard' :
                fieldStyles.presentation === 'stackLabel' ? 'outlined' :
                    fieldStyles.presentation : 'outlined'
        return (
            !errorComponent ?
                (
                    <FieldWrapper
                        isHidden={isHidden}
                        dropdown={dropdown ? dropdown : `${entity}DropdownList`}
                        history={history}
                        record={this.props.values}
                        filterValue={filterValue}
                        path={path}
                        disabled={isDisabled}
                        setValue={this.onChangeFromDropDown}
                        setInitialValue={this.setInitialValue}
                        setDropdownState={this.setDropdownState}
                        fieldRef={this.fieldRef}
                        fieldStyles={fieldStyles}
                        labelStyles={labelStyles}
                        dropdownStyles={dropdownStyles}
                        showLabel={showLabel}
                        label={label}
                        goBack={goBack}
                        focusNow={focusNow}
                        required={required}
                        isMobile={isMobile}
                        isOpenCreate={isOpenCreate}
                        dropdownProps={{
                            createScreen,
                            restrictCreate,
                            setCreatedRecord: this.setCreatedRecord,
                            entity
                        }}
                        dropdownContext={dropdownContextValue}
                        doActions={doActions}
                        globalValues={globalValues}
                        screenName={screenName}
                        fieldValue={fieldValue}
                    >
                        <FormControl classes={{root: classes.formControl}}
                                     fullWidth={isMobile ? true : fieldStyles.fullWidth}
                                     style={{width: fieldStyles.fullWidth ? '100%' : fieldStyles.width}}

                        >
                            {isArray ? (
                                <ArrayField
                                    fieldValue={fieldValue}
                                    errors={errors}
                                    error={error}
                                    disabled={isDisabled}
                                    required={required}
                                    type={type}
                                    onChange={this.onChange}
                                    onChangeTextField={this.onChangeField}
                                    onBlur={this.onBlur}
                                    fieldStyles={fieldStyles}
                                    fieldRef={this.fieldRef}
                                    classes={classes}
                                    field={field}
                                    loading={loading}
                                    isOpen={isOpen}
                                    swapItems={this.swapItems}
                                    endDrag={this.endDrag}
                                    autofocus={autofocus}
                                    path={path}
                                    label={label}
                                    isMobile={isMobile}
                                    openCreatePopup={() => this.openCreatePopup(entity)}
                                    restrictCreate={restrictCreate}
                                    fieldPresentation={fieldPresentation}
                                    placeholder={placeholder}
                                    events={events}
                                    doActions={doActions}
                                />
                            ) : (
                                <SimpleField
                                    fieldValue={fieldValue}
                                    error={error}
                                    disabled={isDisabled}
                                    required={required}
                                    type={type}
                                    onChange={this.onChange}
                                    onChangeTextField={this.onChangeField}
                                    onBlur={this.onBlur}
                                    fieldStyles={{...fieldStyles, conditionalStyles}}
                                    fieldRef={this.fieldRef}
                                    classes={classes}
                                    field={field}
                                    isOpen={isOpen}
                                    loading={loading}
                                    autofocus={autofocus}
                                    onFocus={onFocus}
                                    onKeyDown={onKeyDown}
                                    onBlurProps={onBlur}
                                    id={id}
                                    label={label}
                                    isMobile={isMobile}
                                    openCreatePopup={() => this.openCreatePopup(entity)}
                                    restrictCreate={restrictCreate}
                                    fieldPresentation={fieldPresentation}
                                    placeholder={placeholder}
                                    componentId={this.props.field.id}
                                    screenName={screenName}
                                    path={path}
                                    events={events}
                                    doActions={doActions}
                                />
                            )}
                            <FieldErrorMessage message={error}/>
                        </FormControl>
                    </FieldWrapper>
                )
                :
                (<span>Something bad with field</span>)

        );
    }
}

TypeEntity.propTypes = {
    errors: PropTypes.array,
    //the object of field
    field: PropTypes.object.isRequired,
    fieldStyles: PropTypes.object.isRequired,
    labelStyles: PropTypes.object.isRequired,
    values: PropTypes.any.isRequired,
    setValue: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    //for table fields
    focusNow: PropTypes.bool,
    onBlurFromCell: PropTypes.func,
    onKeyDown: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    setDropdownState: PropTypes.func,
    onSelect: PropTypes.func, //callback after selecting value from dropdown
    globalValues: PropTypes.object
};

TypeEntity.defaultProps = {
    errors: [], //field errors
    goBack: () => {
    }, //goBack from router
    setValue: () => {
    }, //set final value, return (value, path, trackChange)
    onFocus: () => {
    }, //input onFocus, return event
    onBlur: () => {
    }, //input onBlur, return event
    onKeyDown: () => {
    }, //input keyDown, return event
    setDropdownState: () => {
    }, //control dropdown open/closed, return boolean
    values: {}, //all values
    events: [],
    labelStyles: {}, //styles for label
    fieldStyles: {} //styles for input
};

export default withStyles(styles)(TypeEntity);


